export const createAddPassiveInputConnectionToAudioNode = insertElementInSet => {
  return (passiveInputs, input, _ref, ignoreDuplicates) => {
    let [source, output, eventListener] = _ref;
    const passiveInputConnections = passiveInputs.get(source);
    if (passiveInputConnections === undefined) {
      passiveInputs.set(source, new Set([[output, input, eventListener]]));
    } else {
      insertElementInSet(passiveInputConnections, [output, input, eventListener], passiveInputConnection => passiveInputConnection[0] === output && passiveInputConnection[1] === input, ignoreDuplicates);
    }
  };
};